import React from 'react';
import SearchBar from '@frontend/Components/Inputs/SearchBar';
import type { SearchElement as SearchElementType } from '@frontend/Models/TopBar';

/**
 * SearchElement - Wrapper for SearchBar component with TopBar configuration
 * 
 * Integrates the existing SearchBar component into the UnifiedTopBar system.
 * Provides column filtering and search functionality.
 * 
 * @param type - Element type identifier ('search')
 * @param onSearch - Callback when search is performed (term, column)
 * @param columns - Column options for filtering (Record<label, value>)
 * @param defaultSelectedColumn - Default selected column
 * @param placeholder - Optional placeholder text
 * @param condition - Optional conditional rendering function
 */
const SearchElement: React.FC<SearchElementType> = ({
  onSearch,
  columns,
  defaultSelectedColumn,
  placeholder,
  debounceMs,
  condition,
}) => {
  // Conditional rendering - don't render if condition returns false
  if (condition && !condition()) {
    return null;
  }

  const resolvedDebounce = debounceMs ?? 0;

  return (
    <SearchBar
      onSearch={(term: string, column?: string | null) => {
        onSearch(term, column || '')
      }}
      columns={columns}
      defaultSelectedColumn={defaultSelectedColumn}
      placeholder={placeholder}
      debounceMs={resolvedDebounce}
      style={{ width: '25vw' }}
    />
  );
};

export default SearchElement;

